import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from '../views/unauthenticated/login/Login';
import { SetNewPassword } from '@/components/views/unauthenticated/setNewPassword/SetNewPassword';
import { ResetPassword } from '@/components/views/unauthenticated/resetPassword/ResetPassword';
import { AppPaths } from '@/configs/appPaths';

export const UnauthenticatedApp: React.FC = () => {
	return (
		<Routes>
			<Route path={AppPaths.LOGIN} element={<Login />} />
			<Route path={AppPaths.SET_PASSWORD} element={<SetNewPassword />} />
			<Route path={AppPaths.RESET_PASSWORD} element={<ResetPassword />} />
			<Route path="*" element={<Navigate to={`/${AppPaths.LOGIN}`} />} />
		</Routes>
	);
};
